"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.AppointmentInfoForm = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _uiTheme = require("@kyruus/ui-theme");
const AppointmentInfoForm = exports.AppointmentInfoForm = /*#__PURE__*/(0, _base.default)('form', process.env.NODE_ENV === "production" ? {
  target: "eqmfpgd0"
} : {
  target: "eqmfpgd0",
  label: "AppointmentInfoForm"
})("font-family:", (0, _uiTheme.fromTheme)('font_face'), ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0FwcG9pbnRtZW50SW5mby9zdHlsZXMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR2lEIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0FwcG9pbnRtZW50SW5mby9zdHlsZXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBmcm9tVGhlbWUgfSBmcm9tICdAa3lydXVzL3VpLXRoZW1lJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuZXhwb3J0IGNvbnN0IEFwcG9pbnRtZW50SW5mb0Zvcm0gPSBzdHlsZWQoJ2Zvcm0nKWBcbiAgZm9udC1mYW1pbHk6ICR7ZnJvbVRoZW1lKCdmb250X2ZhY2UnKX07XG5gO1xuIl19 */"));